import axios from 'axios';
import { put } from 'redux-saga/effects';

import { Creators } from './actions';
import { apiEndpoints } from '../../../../config/config';

// *************************** Fetch Banner Saga ***************************
// export function* fetchBannerSaga(action) {
//   try {
//     yield put(Creators.fetchBannerStart());
//     const url = yield apiEndpoints.bannerData;
//     const res = yield axios.get(url);
//     const bannerData = [];
//     for (let key in res.data.TrendingPosts) {
//       bannerData.push({
//         id: key,
//         ...res.data.TrendingPosts[key]
//       });
//     }
//     yield put(Creators.fetchBannerSuccess(bannerData));
//   } catch (err) {
//     yield put(Creators.fetchBannerFailure(err));
//   }
// }
// ______________________________________________________________________________

// *************************** Fetch Trending Tags Saga ***************************
// export function* fetchTrendingTagsSaga(action) {
//   try {
//     yield put(Creators.fetchTrendingTagsStart());
//     const url = yield apiEndpoints.trendingTags;
//     const res = yield axios.get(url);
//     const trendingTags = [];
//     if (res.data.success === 1) {
//       for (let key in res.data.tags) {
//         trendingTags.push({
//           id: key,
//           ...res.data.tags[key]
//         });
//       }
//     }
//     yield put(Creators.fetchTrendingTagsSuccess(trendingTags));
//   } catch (err) {
//     yield put(Creators.fetchTrendingTagsFailure(err));
//   }
// }
// ______________________________________________________________________________

// *************************** Fetch Top Results Saga ***************************
export function* fetchTopResultsSaga(action) {
  // console.log('action: ', action);
  try {
    yield put(Creators.fetchTopResultsStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield `${apiEndpoints.searchInput}/results/${action.query}`;
    } else {
      url = yield `${apiEndpoints.searchInput}/results/${action.query}/page/${
        action.pageNumber
      }`;
    }
    // console.log('url: ', url);
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const topResults = [];
    if (res.data.success === 1) {
      for (let key in res.data.searchResults) {
        topResults.push({
          id: key,
          ...res.data.searchResults[key]
        });
      }
    }
    yield put(Creators.fetchTopResultsSuccess(topResults));
  } catch (err) {
    yield put(Creators.fetchTopResultsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Top Reviews For Search Saga ***************************
export function* fetchTopReviewsForSearchSaga(action) {
  try {
    yield put(Creators.fetchTopReviewsForSearchStart());
    const url = yield apiEndpoints.topReviews;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const topReviewsForSearch = [];
    if (res.data.success === 1) {
      for (let key in res.data.Top) {
        topReviewsForSearch.push({
          id: key,
          ...res.data.Top[key]
        });
      }
    }
    // console.log('topReviewsForSearch: ', topReviewsForSearch);
    yield put(Creators.fetchTopReviewsForSearchSuccess(topReviewsForSearch));
  } catch (err) {
    yield put(Creators.fetchTopReviewsForSearchFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Increase Post Count Saga ***************************
// export function* increasePostCountSaga(action) {
//   // console.log('action: ', action);
//   try {
//     const url = yield `${apiEndpoints.increasePostCount}/${action.postId}`;
//     const res = yield axios.post(url);
//     // console.log('res: ', res);
//     if (res.data.success === 1) {
//       return;
//     }
//   } catch (err) {
//     console.log('Error came while increasing post count');
//     return;
//   }
// }
// ______________________________________________________________________________
